import { createElement } from 'react';
import { CHART_EMPTY_STATE_FILTER_HINT } from '@/ui/composites/charts/ChartEmptyState';
import { DataGridEmptyState } from './dataGridStates';
import type { ReactElement } from 'react';

type DataGridStateOptions = {
  emptyTitle?: string;
  emptyBody?: string;
  error?: boolean;
  errorTitle?: string;
  errorBody?: string;
  errorAction?: ReactElement;
};

type DataGridDefaults = {
  pageSizeOptions: number[];
  initialState: {
    pagination: { paginationModel: { page: number; pageSize: number } };
    sorting: { sortModel: [] };
  };
  slots: {
    noRowsOverlay: () => ReactElement;
    noResultsOverlay: () => ReactElement;
  };
  slotProps: { loadingOverlay: { variant: 'skeleton'; noRowsVariant: 'skeleton' } };
};

const renderEmptyState = (props: {
  title: string;
  body?: string;
  action?: ReactElement;
}): ReactElement => createElement(DataGridEmptyState, props);

export const getDataGridDefaults = (options: DataGridStateOptions = {}): DataGridDefaults => {
  const {
    emptyTitle = 'No results',
    emptyBody = CHART_EMPTY_STATE_FILTER_HINT,
    error = false,
    errorTitle = 'Something went wrong',
    errorBody = 'Refresh or try again later.',
    errorAction,
  } = options;

  const overlayProps = error
    ? { title: errorTitle, body: errorBody, action: errorAction }
    : { title: emptyTitle, body: emptyBody };

  return {
    pageSizeOptions: [5, 10, 25, 50],
    initialState: {
      pagination: { paginationModel: { page: 0, pageSize: 5 } },
      sorting: { sortModel: [] },
    },
    slots: {
      noRowsOverlay: () => renderEmptyState(overlayProps),
      noResultsOverlay: () => renderEmptyState(overlayProps),
    },
    slotProps: { loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } },
  };
};

export type { DataGridDefaults, DataGridStateOptions };
